import { z } from "zod";
import type { TenantLicensePlan } from "./common.js";

export const issueLeaseSchema = z.object({
  deviceId: z.string().min(1),
  appVersion: z.string().optional()
});

export type IssueLeaseInput = z.infer<typeof issueLeaseSchema>;

export interface EntitlementLease {
  tenantId: string;
  /**
   * 单账号主体 ↔ 单登录账号合并 schema 后，此字段值与 `tenantId` 相同；
   * 保留是为了与桌面端 / Rust 已签发的 lease canonical payload 形态向后兼容（包含字段在签名中）。
   */
  userId: string;
  deviceId: string;
  plan: TenantLicensePlan;
  entitlements: string[];
  issuedAt: string;
  expiresAt: string;
  offlineGraceUntil: string;
  appMinVersion: string;
}

export interface SignedEntitlementLease {
  lease: EntitlementLease;
  signature: string;
}
